import { LinkedList } from './LinkedList.js';

let
  canvas,
  objects,
  depth = 800;


function preload() {
  fonts = [
    loadFont('fonts/Chakra_Petch/ChakraPetch-Regular.ttf'),
    loadFont('fonts/Coda_Caption/CodaCaption-ExtraBold.ttf'),
    loadFont('fonts/Comfortaa/Comfortaa-VariableFont_wght.ttf'),
    loadFont('fonts/Monoton/Monoton-Regular.ttf'),
    loadFont('fonts/Permanent_Marker/PermanentMarker-Regular.ttf'),
  ];
}

function setup() {
  nFonts = fonts.length;
  texts = [
    `{ CODE_THE_WEB }`,
    `“Do not repeat yourself.”`,
    `P.G.M.I.`,
    `1984`,
    `“I like purple.”`,
    `Hyper Text Markup Language`,
    /*
    `“Programming isn't about what you know; it's about what you can figure out.” - Chris Pine`,
    `“The only way to learn a new programming language is by writing programs in it.” - Dennis Ritchie`,
    `“Sometimes it's better to leave something alone, to pause, and that's very true of programming.” - Joyce Wheeler`,
    `“In some ways, programming is like painting. You start with a blank canvas and certain basic raw materials. You use a combination of science, art, and craft to determine what to do with them.” - Andrew Hunt`,
    `“Testing leads to failure, and failure leads to understanding.” - Burt Rutan`,
    `“The best error message is the one that never shows up.” - Thomas Fuchs`,
    `“The most damaging phrase in the language is.. it's always been done this way” - Grace Hopper`,
    */
  ];
  objects = new LinkedList();
  maxObjects = 16;

  canvas = createCanvas(windowWidth, windowHeight, WEBGL);
  frameRate(30);

  angleMode(DEGREES);
  strokeCap(SQUARE);

  /* DEBUG
  canvas.mouseClicked(() => {
    console.log('CLICKED:', mouseX, mouseY);
    if (mouseX < width/2) {
      console.log('REMOVE');
      objects._first.remove();

    } else {
      console.log('ADD');
      objects.add(new TextObj('TEST', fonts[round(random(0, fonts.length-1))]));
    }
    console.log(objects);
  });
  */
}

function windowResized() {
  resizeCanvas(windowWidth, windowHeight);
}

function draw() {
  background(220);

  if (objects.length < maxObjects) {
    objects.add(new TextObj(texts[round(random(0, texts.length-1))], fonts[round(random(0, fonts.length-1))]));
  }

  objects.iterate(obj => {
    return obj.update();
  });
  objects.iterate(obj => {
    return obj.render();
  });
}

class TextObj {
  constructor(text, font) {
    this.text = text;
    this.font = font;
    this.speed = random(2, 12);
    this.size = (windowWidth * windowHeight * random(.5, 2.0)) / 10000;
    this.state = 'ALIVE';

    this.points = this.font.textToPoints(this.text, 0, 0, this.size, {
      sampleFactor: 0.15,
      simplifyThreshold: 0
    });
    this.bounds = this.font.textBounds(this.text, 0, 0, this.size);

    this.p = createVector(
      -width - this.bounds.w,
      random(0, height*.75) - height/2,
      random(-depth, 0)
    );
  }
  update() {
    switch (this.state) {
    case 'ALIVE':
      this.p.add(this.speed, 0, 0);
      if (this.p.x > width) this.state = 'DEAD';
      break;
    case 'DEAD':
      console.log('DEAD');
      return false;
    }
  }
  render() {
    push();
    rotateZ(20);
    rotateX(40);

    push();
    translate(this.p.x, this.p.y, this.p.z);
    noFill();
    let alpha = ((depth+this.p.z) / depth) * 255;
    stroke(color(0, 0, 0, alpha));
    beginShape();
    for (let i = 0; i < this.points.length; i++) {
      let p = this.points[i];
      vertex(p.x, p.y + noise(p.x, p.y + this.p.x, p.z)*10, p.z);
    }
    endShape();
    pop();

    pop();
  }
}
